export default "__VITE_ASSET__DSD4AoWa__"